import React, { useState } from "react";
import kitchendinning from "../assets/kitchendining.jpg";
import lounge from "../assets/lounge.jpg";
import bedroom from "../assets/bedroom.jpg";
import laundry from "../assets/laundry.jpg";
import officeandmedicationroom from "../assets/officeandmedicationroom.jpg";
import kitchen from "../assets/kitchen.jpg";
import "../style/imagegallery2.css";

const ImageGallery2 = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    { thumb: kitchendinning, full: kitchendinning, title: "Kitchen Dinning" },
    { thumb: lounge, full: lounge, title: "Lounge" },
    { thumb: bedroom, full: bedroom, title: "Bedroom" },
    { thumb: laundry, full: laundry, title: "Laundry" },
    {
      thumb: officeandmedicationroom,
      full: officeandmedicationroom,
      title: "Office",
    },
    { thumb: kitchen, full: kitchen, title: "Kitchen" },
  ];

  return (
    <div className="gallery2-container">
      <div className="gallery2-grid">
        {images.map((img, index) => (
          <div key={index} className="gallery2-item">
            <img src={img.thumb} alt={`Thumbnail ${index}`} loading="lazy" />
            <div>
              <h4>{img.title}</h4>
              <button onClick={() => setSelectedImage(img.full)}>View</button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedImage && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedImage(null)} // close when clicking outside
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Full View" loading="lazy" />
            <button
              className="close-btn"
              onClick={() => setSelectedImage(null)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageGallery2;
